module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-box-26d2c61e7e4c5f10aee0dc2cf290061c.svg";